<template>
    <v-container>
        <form @submit.prevent="validateFields">
        <v-card flat class="mt-7 pa-5">
        <v-toolbar flat width="100%">
            <v-toolbar-title class="text-h4">{{$t('animal.genotypeData')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="cancelpage" outlined right height="44" width="116" color="primary">
                {{$t('cancel')}}
            </v-btn>
            <v-btn  right class="ml-5" height="44" width="116" color="primary" type="submit">
                {{$t('submit')}}
            </v-btn>
        </v-toolbar>
        </v-card>
        <v-expansion-panels focusable class="mt-5" v-model="panel">
            <v-expansion-panel >
                <v-expansion-panel-header  class="text-h6 font-weight-bold">{{$t('animal.genotypeData')}}</v-expansion-panel-header>
                <v-expansion-panel-content class="pt-5">
                    <v-row>                      
                        <v-col cols="4" >
                            <label class="label">{{$t('animal.genotypeDataInfo.genotypeAnimalID')}}  
                                <v-tooltip top color="black" max-width="350">
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                        mdi-information-outline
                                    </v-icon>
                                    </template>
                                    <span
                                    >{{$t('animal.genotypeDataInfo.iDTubeBloodSampleAnimalNumberGenotypingService')}}.</span
                                    >
                                </v-tooltip>
                            </label>
                            <v-text-field
                                type="text"
                                outlined
                                dense
                                :placeholder="$t('animal.genotypeDataInfo.genotypeAnimalID')"
                                v-model="animalGeneData.genotypeAnimalId"
                                :error-messages="errors.genotypeAnimalId"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" >
                            <label class="label">{{$t('animal.genotypeDataInfo.geneticTechnicianName')}}
                                <v-tooltip top color="black" max-width="350">
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                        mdi-information-outline
                                    </v-icon>
                                    </template>
                                    <span
                                    >{{$t('animal.genotypeDataInfo.NameTechnicianBloodSamplesAnimal')}}.</span
                                    >
                                </v-tooltip>
                            </label>
                            <v-text-field
                                type="text"
                                outlined
                                dense
                                :placeholder="$t('animal.genotypeDataInfo.geneticTechnicianName')"
                                v-model="animalGeneData.technicianName"
                                :error-messages="errors.technicianName"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" >
                            <label class="label">{{$t('animal.genotypeData')}}
                                <v-tooltip top color="black" max-width="350">
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                        mdi-information-outline
                                    </v-icon>
                                    </template>
                                    <span
                                    >{{$t('animal.genotypeDataInfo.sNPData')}}.</span
                                    >
                                </v-tooltip>
                            </label>
                            <v-text-field
                                type="text"
                                outlined
                                dense
                                :placeholder="$t('animal.genotypeData')"
                                v-model="animalGeneData.genoTypeData"
                                :error-messages="errors.genoTypeData"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="8" >
                            <label class="label">{{$t('animal.genotypeDataInfo.genotypingServiceNote')}}
                                <v-tooltip top color="black" max-width="350">
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                        mdi-information-outline
                                    </v-icon>
                                    </template>
                                    <span
                                    >{{$t('animal.genotypeDataInfo.InfoGenotypingGenotypingTechnology')}}.</span
                                    >
                                </v-tooltip>
                            </label>
                            <v-textarea
                                outlined
                                rows="1"
                                dense
                                v-model="animalGeneData.genotypingServiceNote"
                                :error-messages="errors.genotypingServiceNote"
                            ></v-textarea>
                        </v-col>
                        <v-col cols="4" >
                            <label class="label">{{$t('animal.genotypeDataInfo.numberOfSNPs')}}
                                <v-tooltip top color="black" max-width="350">
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                        mdi-information-outline
                                    </v-icon>
                                    </template>
                                    <span
                                    >{{$t('animal.genotypeDataInfo.numberOfSNPsAnimalGenotyped')}}.</span
                                    >
                                </v-tooltip>
                            </label>
                            <v-text-field
                                type="number"
                                step=".1"
                                min="0"
                                outlined
                                dense
                                :placeholder="$t('animal.genotypeDataInfo.numberOfSNPs')"
                                v-model="animalGeneData.numberOfSNP"
                                :error-messages="errors.numberOfSNP"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <div class="d-flex justify-end">
            <v-btn @click="cancelpage" outlined right height="44" width="116" color="primary" class="mr-2 mt-15">
                {{$t('cancel')}}
            </v-btn>
            <v-btn  right class="mt-15" height="44" width="116" color="primary" type="submit">
                {{$t('submit')}}
            </v-btn>
        </div>
        </form>
        <DataLostWarning
            :dialogI="dataLossWarning"
            v-if="dataLossWarning"
            @closeDialog="closeWarningMessage"
            @saveData="closeWarningMessage"  
        ></DataLostWarning>
    </v-container>
</template>

<script>

    import AnimalService from "@/_services/AnimalService"
    import loading from "@/mixins/LoadingMixin";

    export default {
    created() {
        const fetchData = async () => {
            await this.getAnimalGenotypeData()
        };
        fetchData();
    },
    beforeRouteLeave(to, from, next) {
		if(this.formChanged) {
			this.promptToRoute = to;
			this.dataLossWarning = true;
			return
		}
		next();
	},
    watch: {
        animalGeneData: {
        handler() {
            this.formChanged = true;
        },
        deep: true
        },
    },
    data() {
        return {
            dataLossWarning: false,
            formChanged: false,
            promptToRoute: null,
            error: false,
            errors: { 
                genotypeAnimalId: "",
                technicianName: "",
                genoTypeData: "",
                genotypingServiceNote: "",
                numberOfSNP: ""
            },
            panel:0,
            genoDataRegistered: false,
            treatmentDateMenu: false,
            animalGeneData: {
                animalNumber: this.$route.params.animal_number,
                genotypeAnimalId: "",
                technicianName: "",
                genoTypeData: "",
                genotypingServiceNote: "",
                numberOfSNP: ""
            }
        }
    },
    methods: {
        closeWarningMessage(stay) {
            this.dataLossWarning = false;
            if(!stay) {
                this.formChanged = false;
                this.$router.push(this.promptToRoute)
            }
        },
        cancelpage() {
            this.$router.push({name: 'AnimalGeneData', params:{ animal_number: this.$route.params.animal_number}})
        },

        async getAnimalGenotypeData() {
            this.startLoading()
            AnimalService.getAnimalGenotypeData(this.$route.params.animal_number)
            .then(res => {
                if(res.success){
                    if(res.data.genotype){
                        this.animalGeneData = res.data.genotype;
                        this.genoDataRegistered = true
                    }
                    this.stopLoading()
                }
            })
            .catch( err => {
                console.log('err',err.data); 
                this.stopLoading()
            })
        },
        updateGenotypeData() {
            // if(!this.validateFields()) return
            this.startLoading()
            this.formChanged = false;
            AnimalService.updateAnimalGenotypeData(this.animalGeneData, this.genoDataRegistered)
            .then( res => {
                if(res.success){
                    this.$notify({
						title: this.$t('animal.genotypeDataInfo.animalGenoDataUpdatedSuccessfully'),
						text: res.message,
						type: 'success',
					});
                    this.cancelpage()
                }else{
                    this.$notify({
						title: this.$t('animal.genotypeDataInfo.animalGenoDataNotUpdated'),
						text: res.message,
						type: 'error',
					});
                }
                this.stopLoading()
            })
            .catch( err => {
                this.$notify({
                    title: this.$t('animal.genotypeDataInfo.animalGenoDataNotUpdated'),
                    text: '',
                    type: 'error',
                    position: 'top right'
                });
                console.log(err.data); this.stopLoading()
                
            })
        },
        validateFields() {
            this.error = false;
            // Object.keys(this.errors).forEach(key => {
            //     this.errors[key] = '';
            // })
            // console.log(this.animalGeneData)
            // if(this.animalGeneData.genotypeAnimalId.trim() == "") {
            //     this.error = true;
            //     this.errors.genotypeAnimalId = this.$t('animal.genotypeDataInfo.animalIDIsRequired');
            // }
            // if(this.animalGeneData.technicianName.trim() == "") {
            //     this.error = true;
            //     this.errors.technicianName = this.$t('animal.genotypeDataInfo.techNameIsRequired');
            // }else if(!this.animalGeneData.technicianName.match(/^[a-zA-Z\s]+$/)){
            //     this.error = true;
            //     this.errors.technicianName = this.$t('animal.genotypeDataInfo.onlyAlphabetsAreAllowed');
            // }


            // if(this.animalGeneData.genoTypeData.trim() == "") {
            //     this.error = true;
            //     this.errors.genoTypeData = this.$t('animal.genotypeDataInfo.genoDataIsRequired');
            // }
            // if(this.animalGeneData.genotypingServiceNote.trim() == "") {
            //     this.error = true;
            //     this.errors.genotypingServiceNote = this.$t('animal.genotypeDataInfo.serviceNoteIsRequired');
            // }
            // if(this.animalGeneData.numberOfSNP == "") {
            //     this.error = true;
            //     this.errors.numberOfSNP = this.$t('animal.genotypeDataInfo.sNPIsRequired');
            // }
            
            if(!this.error)
                this.updateGenotypeData()
            else
                return false;
        }
    },
    mixins: [loading]
}
</script>
<style lang="scss" scopped>
    label {
        display: inline-block;
        margin-bottom: .5rem;
        font-size: 14px;
        font-family: Poppins-Medium;
        letter-spacing: 0.5px;  
        white-space: nowrap;
    }
</style>